<template>
  <!--begin::Layout-->
  <div class="d-flex flex-column flex-xl-row">
    <!--begin::Content-->
    <div class="flex-lg-row-fluid">
      <ul class="nav nav-custom nav-pills border-0 fs-4 fw-bold mb-8">
        <li class="nav-item">
          <router-link
            class="nav-link text-active-light me-6"
            to="/stilldeploy/overview"
            active-class="active"
          >
            {{$t("Vue d'ensemble")}}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link text-active-light me-6"
            to="/stilldeploy/ticket"
            active-class="active"
          >
            {{$t("Gestion des tickets")}}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link text-active-light me-6"
            to="/stilldeploy/stock"
            active-class="active"
          >
            {{$t("Gestion des stocks")}}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link text-active-light me-6"
            to="/stilldeploy/sites"
            active-class="active"
          >
            {{$t("Gestion des sites")}}
          </router-link>
        </li>
      </ul>
      <router-view></router-view>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "customer-details",
  setup() {
    onMounted(async () => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs("Outils de déploiement", []);
    });
  },
});
</script>
